<div class="min-h-screen flex bg-surface-50 dark:bg-surface-950">

  <!-- 🔹 Left Branding Section -->
  <div class="hidden lg:flex w-1/2 items-center justify-center bg-primary-50 dark:bg-primary-500/10">
    <div class="text-center px-10">
      <div class="flex items-center justify-center gap-3 mb-6">
        <i class="pi pi-shield text-4xl text-primary-500"></i>
        <span class="text-2xl font-semibold text-surface-900 dark:text-surface-0">
          Auth Server
        </span>
      </div>

      <p class="text-surface-600 dark:text-surface-400  leading-relaxed max-w-sm mx-auto">
        Secure multi-tenant authentication platform for managing users,
        access control, and enterprise identity services.
      </p>
    </div>
  </div>

  <!-- 🔹 Right Login Section -->
  <div class="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12">

    <div class="w-full max-w-md">

      <!-- 🔹 Logo (Mobile) -->
      <div class="lg:hidden flex items-center justify-center gap-2 mb-6">
        <i class="pi pi-shield text-2xl text-primary-500"></i>
        <span class="text-lg font-semibold text-surface-900 dark:text-surface-0">
          Auth Server
        </span>
      </div>

      <!-- 🔹 Card -->
      <div class="bg-white dark:bg-surface-900 border border-surface-200 dark:border-surface-700 rounded-xl shadow-sm p-8">

        <!-- Header -->
        <div class="text-center mb-6">
          <h2 class="text-xl font-semibold text-surface-900 dark:text-surface-0">
            Sign in
          </h2>
          <p class=" text-surface-500 dark:text-surface-400 mt-1">
            Use your organization account to continue
          </p>
        </div>

        <!-- 🔹 Login Button -->
        <p-button
          label="Continue with SSO"
          icon="pi pi-shield"
          size="large"
          [loading]="isLoading"
          (click)="loginWithOAuth()"
          styleClass="w-full justify-center"
        ></p-button>

        <!-- Info -->
        <div class="flex items-start gap-2 mt-5 text-xs text-surface-500 dark:text-surface-400">
          <i class="pi pi-lock mt-0.5"></i>
          <span>
            You will be redirected to your organization's secure authentication portal.
          </span>
        </div>

      </div>

      <!-- 🔹 Footer -->
      <div class="text-center mt-6 text-xs text-surface-500 dark:text-surface-400">
        ©  Auth Server • All rights reserved
      </div>

    </div>
  </div>

</div>
